import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { formatDate } from '@angular/common';
import { ParamMap, ActivatedRoute } from '@angular/router';
import { Table } from 'primeng/table';

import { ArkUserType, OnDemandTaskViewModel } from '../../core/api/models';
import { DeveloperApiService } from '../../core/api/services';
import { Utils } from '../../core/utils';
import { AuthService } from '../../main/auth.service';
import { AlertService } from '../../shared/services/alert.service';

@Component({
  selector: 'app-on-demand-tasks-component',
  templateUrl: './on-demand-tasks.component.html',
  standalone: false
})
export class OnDemandTasksComponent implements OnInit, AfterViewInit {
  public pageTitle: string = 'On Demand Tasks';

  list: OnDemandTaskViewModel[] = [];
  loadingList: boolean = true;
  loading: boolean = false;

  selectedTask: null | OnDemandTaskViewModel = null;
  params: string = '-DB:OptoDev';

  @ViewChild('dt1') table?: Table;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private apiService: DeveloperApiService) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      console.info('Loading ', params);
    });

    this.authService.checkIfAutorized([ArkUserType.Developer, ArkUserType.Admin]);
  }

  ngAfterViewInit(): void {
    this.loadTable();
  }

  loadTable() {
    this.loadingList = true;
    this.apiService.ListOnDemandTasks()
      .forEach(
        (result) => {
          this.list = result;
          this.loadingList = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
          });
  }

  clear(table: Table) {
    this.table = table;
    table.clear();
  }

  openRunDialog(item: OnDemandTaskViewModel) {
    if (!item.Active || item.PendingRunID)
      return;

    this.selectedTask = item;
    this.params = '-DB:OptoDev';
  }

  cancelPendingRequest(item: OnDemandTaskViewModel) {
    if (!this.canCancelPendingRequest(item))
      return;

    this.loading = true;
    this.apiService.CancelOnDemandTaskRequest({ body: { id: item.ID } })
      .forEach(
        (message) => {
          this.loading = false;
          this.alertService.info(message);
          this.loadTable();
        }).catch(
          err => {
            this.loading = false;
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  canCancelPendingRequest(item: OnDemandTaskViewModel) {
    return item.ID && item.PendingRunID && !item.PendingStartRunningDate;
  }

  runTask() {
    if (!this.selectedTask || !this.selectedTask.ID)
      return;

    this.loading = true;
    this.apiService.RunOnDemandTask({ body: { id: this.selectedTask.ID, params: this.params } })
      .forEach(
        (message) => {
          this.loading = false;
          this.alertService.info(message);
          this.selectedTask = null;
          this.loadTable();
        }).catch(
          err => {
            this.loading = false;
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  getTimeFromNow(date: string | null | undefined) {
    if (!date)
      return '';

    if ((new Date().getTime()) - (new Date(date).getTime()) > 1000 * 60 * 60 * 36) {
      return formatDate(date, 'shortDate', 'en-US');
    }
    const runDate: Date = new Date(date);
    return Utils.getTimeFromNow(runDate);
  }

  formatMountainTime(date: string | null | undefined) {
    if (!date)
      return '';

    return Utils.formatMountainTime(date);
  }
}
